/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { PartnerGuard } from '../guards/RolesGuard';
import { useTheme } from '../utils/theme-context';
import { AI_AGENTS } from '../utils/constants/ai-agents';
import { CHAT_ACTIONS_ADMIN } from '../utils/constants/chat-actions';
// import { tryToFetchTeamMembersSidebar } from '../store/brokers/partners/teams/teamsSlice';
import { IPaginationPayload } from '../interfaces/shared/IPaginationPayload';
import { tryToCreateChatMessage, tryToCreateChatMessageExecu } from '../store/brokers/partners/chats/ChatsSlice';
import { openChat, closeChat } from '../store/brokers/partners/chats/ChatsUISlice';
import { tryToFetchActiveTrips } from '../store/admin/trips/adminTripsSlice';
import NewChatModal from '../components/new-chat/NewChatModal';
import DocEditor from '../components/reports/ReportEditModal';
import ChatDrawer from '../components/search-chat/chat';
import ExecutiveTrips from './layout-admin-components/ExecutiveTrips';
import RightSidebar from './layout-admin-components/RightSidebar';
import Sidebar from './layout-admin-components/Sidebar';
import SearchInput from '../shared/chat-bar/search-input';
import DownloadReviewsModal from '../components/DownloadReviewsModal';
import HodReportModal from '../features/admin/homepage/modals/HodReportModal';
import TmReportModal from '../features/admin/homepage/modals/TmReportModal';

type Trip = {
    _id: string;
    startDate: string;
    endDate: string;
    active?: boolean;
    status?: string;
    itinerary?: { journeyTitle?: string };
    trainManager?: { username?: string };
};

const LayoutAdmin = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { theme } = useTheme();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
    const [isRightSidebarCollapsed, setIsRightSidebarCollapsed] = useState(true);
    const [chatIsWaiting, setChatIsWaiting] = useState(false);
    const [chatData, setChatData] = useState<any>();
    const [openReportModal, setOpenReportModal] = useState<{ show: boolean, url: string, data: any }>();
    const [showSearchChat, setShowSearchChat] = useState(false);
    const [showAdditionals, setShowAdditionals] = useState<any>('trips');
    const [items, setItems] = useState<Trip[]>([]);
    const [pagination, setPagination] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [loadingMore, setLoadingMore] = useState(false);
    const [reviewsModal, setReviewsModal] = useState(false)
    const [hodReportModal, setHodReportModal] = useState<{ show: boolean; tripId: string; reportType: 'cabin' | 'bar' | 'restaurant' }>({ show: false, tripId: '', reportType: 'cabin' });
    const [tmReportModal, setTmReportModal] = useState<{ show: boolean; tripId: string }>({ show: false, tripId: '' });

    const apiData = useAppSelector((s) => s.adminTrips.execuTrips);
    const loadingTrips = useAppSelector((s) => s.adminTrips?.tripsActiveAreLoading);
    const pageInfo = useAppSelector((s) => s.adminTrips?.execuTrips?.page);
    const chatUi = useAppSelector((state) => state.chatUi);

    const fetchTrips = useCallback(async (pageNumber: number) => {
        try {
            const payload = {
                pageNumber,
                pageSize: pagination.pageSize,
                data: {
                    // startDateMax: new Date().toISOString(),
                    // endDateMin: new Date().toISOString(),
                    status: 'active'
                }
            };
            await dispatch(tryToFetchActiveTrips(payload)).unwrap();
        } catch (err) {
            console.error(err);
        }
    }, [dispatch, pagination.pageSize]);

    useEffect(() => {
        fetchTrips(1);
    }, [fetchTrips]);

    useEffect(() => {
        const interval = setInterval(() => {
            fetchTrips(1);
        }, 60000);

        return () => clearInterval(interval);
    }, [fetchTrips]);

    useEffect(() => {
        setItems(apiData?.elements ?? []);
    }, [apiData?.elements]);

    const hasNextPage = !!pageInfo?.hasNextPage;

    const onShowMore = async () => {
        if (loadingMore) return;
        setLoadingMore(true);
        try {
            const nextPage = (pageInfo?.number ?? pagination.pageNumber) + 1;
            setPagination((p) => ({ ...p, pageNumber: nextPage }));
            await fetchTrips(nextPage);
        } catch (e) {
            console.error(e);
        } finally {
            setLoadingMore(false);
        }
    };

    // const [availableTrips, setAvailableTrips] = useState<any>();

    const onOpenChat = async (data?: any, chatId?: string) => {
        try {
            setSidebarOpen(false);
            setChatIsWaiting(true);
            if (!chatId && !data) {
                await dispatch(closeChat());
            }
            if (data) {
                const formatData = {
                    message: data?.user?.message,
                    files: data?.user?.files
                };
                let response: any
                if (PartnerGuard()) {
                    response = await dispatch(tryToCreateChatMessageExecu(formatData)).unwrap();
                } else {
                    response = await dispatch(tryToCreateChatMessage(formatData)).unwrap();
                }
                const newChatData = [
                    { user: data?.user },
                    {
                        agent: {
                            ...response?.data || {},
                            message: response?.data?.message,
                            files: response?.data?.files || [],
                            createdAt: new Date(),
                            _id: response?.data?.metadata?.messageId,
                        }
                    }
                ];

                setChatData(newChatData);

                dispatch(openChat({
                    chatId: response?.data?.topic || chatId,
                    data: newChatData
                }));
            } else {
                setChatData(undefined);

                dispatch(openChat({
                    chatId: chatId,
                    data: []
                }));
            }
        } catch (err) {
            console.error(err);
        }

        setChatIsWaiting(false);
    };

    const onClickAction = (action: any) => {
        setRightSidebarOpen(false);
        const formatUserRequest = {
            user: {
                message: action.text,
                files: [],
                sort: 2
            }
        };

        setChatData([]);
        dispatch(openChat({ data: [formatUserRequest], action }));
    };


    const onClickShowModal = () => {
        setSidebarOpen(false);
        setShowSearchChat(!showSearchChat);
    };

    const onTryingToOpenChat = (id?: string, action?: any) => {
        setShowSearchChat(false);
        if (action) {
            onClickAction(action);
        } else {
            dispatch(openChat({ chatId: id }));
        }
        setChatData([]);
    };

    const onGettingData = async () => {
        try {
            // const data = {
            //     pageSize: 5,
            //     pageNumber: 1
            // };
            // await dispatch(tryToFetchTeamMembersSidebar(data)).unwrap();
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!chatUi.open) {
            onGettingData();
        }
    }, [chatUi.open]);

    useEffect(() => {
        if (
            chatUi.open &&
            !chatUi.chatData?.length &&
            !chatUi.action &&
            chatUi.chatId
        ) {
            onOpenChat(undefined, chatUi.chatId);
        }
    }, [chatUi]);

    const onCloseChat = () => {
        dispatch(closeChat());
        setChatData(undefined);
    };

    const onClickAdditional = (action: string) => {
        setShowAdditionals(action === showAdditionals ? undefined : action);
    };

    const onOpenTripChat = async (tripId: string) => {
        try {
            dispatch(openChat({
                tripId: tripId,
                data: []
            }));
        } catch (err) {
            console.error(err);
        }
    }

    const onOpenReportModal = (url: string, data: any) => {
        setOpenReportModal({
            show: true,
            url: url,
            data
        })
    }

    const onOpenHodReport = (tripId: string, reportType: 'cabin' | 'bar' | 'restaurant') => {
        setHodReportModal({ show: true, tripId, reportType });
    };

    const onOpenTmReport = (tripId: string) => {
        setTmReportModal({ show: true, tripId });
    };


    return (
        <div className='bg-white dark:bg-bgColor-darkMode flex flex-col min-h-screen'>
            <DownloadReviewsModal open={reviewsModal} onClose={() => setReviewsModal(false)} />
            {sidebarOpen && (
                <div className="fixed inset-0 z-40 flex md:hidden">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setSidebarOpen(false)}></div>
                    <div className="relative bg-white w-70 h-full shadow-xl z-50 flex flex-col">
                        <div className="flex justify-end p-3 pr-[10px] flex-shrink-0">
                            <button onClick={() => setSidebarOpen(false)}>
                                <img src="/assets/shared/close-grey.svg" alt="Close" className="w-5 h-5" />
                            </button>
                        </div>
                        <div className="flex-1 overflow-y-auto">
                            <Sidebar onClickShowModal={onClickShowModal} onClickOpenChat={onOpenChat} isMobile={true} />
                        </div>
                    </div>
                </div>
            )}
            <Sidebar onClickShowModal={onClickShowModal} onClickOpenChat={onOpenChat} />
            <div className={`flex flex-col flex-1 ${isRightSidebarCollapsed ? 'md:pl-64 md:pr-16' : 'md:px-64'}`}>
                <header className='sticky top-0 z-10 flex-shrink-0 flex bg-white dark:bg-bgColor-darkMode p-4 h-16 md:hidden justify-between'>
                    <button
                        type='button'
                        className='text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 px-1'
                        onClick={() => setSidebarOpen(true)}
                    >
                        <img src={theme === 'dark' ? '/assets/navigation-icons/burger-menu-white.svg' : '/assets/navigation-icons/burger-menu.svg'} className='object-contain w-[23px]' />
                    </button>
                    <button
                        type='button'
                        className='text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 px-1'
                        onClick={() => setRightSidebarOpen(true)}
                    >
                        <img src={theme === 'dark' ? '/assets/navigation-icons/left-side-arrow-white.svg' : '/assets/navigation-icons/left-side-arrow.svg'} className='object-contain w-[23px]' />
                    </button>
                </header>
                <main className='flex-1 relative'>
                    <AnimatePresence mode="wait">
                        {(chatUi.open && location?.pathname === '/insights-admin') ? (
                            <ChatDrawer
                                key="chat"
                                isOpen={chatUi.open}
                                chatData={chatUi.chatData}
                                action={chatUi.action}
                                historyId={chatUi.chatId}
                                onClose={onCloseChat}
                                triggerId="rebecca-chat"
                            />
                        ) : (
                            <motion.div
                                key="input"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.3 }}
                                style={{ backgroundColor: theme === 'dark' ? '#050608' : '' }}
                            >

                                {location?.pathname === '/insights-admin' && !PartnerGuard() && (
                                    <div className='py-5 px-4 bg-[#fff] dark:bg-[#111317] min-w-full border-b border-b-1 dark:border-white/10'>
                                        <div className='mb-5'>
                                            {AI_AGENTS?.map((item, idx) => (
                                                <div className='p-2 border-[1px] rounded-[8px] border-solid border-[#F5F5F5] dark:border-transparent'>
                                                    <div key={idx} className='rounded-sm border-[#1E4380] dark:border-borderColor-darkMode pl-2 flex flex-row items-center'>
                                                        <div className='h-[28px] w-[5px] rounded-full bg-black dark:bg-[#00691F] mr-1' />
                                                        <div className='flex flex-row items-center bg-[#F7F9FB] dark:bg-black px-2 rounded-[8px] h-[28px] justify-center'>
                                                            <p className='dark:text-primary-darkMode mr-2 font-inter text-[14px] font-medium'>{item.name}</p>
                                                            <p className=' text-sm font-inter text-[14px] font-normal text-[#A4A7AE]'>{item.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <SearchInput
                                            placeholder={PartnerGuard() ? 'Capture some feedback...' : 'Manage users...'}
                                            chatData={chatData || []}
                                            chatId={chatUi.chatId}
                                            considerDarkMode={true}
                                            isWaiting={chatIsWaiting}
                                            onSendingData={onOpenChat}
                                        />

                                        {!PartnerGuard() &&
                                            <div className='flex flex-row items-center my-3'>
                                                <div className='flex flex-row items-center cursor-pointer mr-6 hover:opacity-90' onClick={() => onClickAdditional('actions')}>
                                                    <p className={`mr-2 dark:text-primary-darkMode transition-colors duration-200 ${showAdditionals === 'actions' ? 'text-[#252B37] font-medium' : 'text-[#535862]'}`}>Actions</p>
                                                    {showAdditionals === 'actions' ? (
                                                        <img src='/svg/arrows_input.svg' className='object-contain w-[20px] dark:contrast-0' alt='collapse' />
                                                    ) : (
                                                        <img src={theme === 'dark' ? '/assets/insights/see-more-icon-white.svg' : '/assets/layout/dots-gray.svg'} className='object-contain w-[20px]' alt='expand' />
                                                    )}
                                                </div>
                                                <div className='flex flex-row items-center cursor-pointer mr-6 hover:opacity-90' onClick={() => onClickAdditional('trips')}>
                                                    <p className={`mr-2 dark:text-primary-darkMode transition-colors duration-200 ${showAdditionals === 'trips' ? 'text-[#252B37] font-medium' : 'text-[#535862]'}`}>Active Trips</p>
                                                    {showAdditionals === 'trips' ? (
                                                        <img src='/svg/arrows_input.svg' className='object-contain w-[20px] dark:contrast-0' alt='collapse' />
                                                    ) : (
                                                        <img src={theme === 'dark' ? '/assets/insights/see-more-icon-white.svg' : '/assets/layout/dots-gray.svg'} className='object-contain w-[20px]' alt='expand' />
                                                    )}
                                                </div>
                                            </div>
                                        }
                                        {showAdditionals === 'actions' && !PartnerGuard() && (
                                            <div className='flex flex-row items-center flex-wrap gap-3'>
                                                {CHAT_ACTIONS_ADMIN?.map((item, idx) => (
                                                    <div
                                                        key={idx}
                                                        onClick={() => onClickAction(item)}
                                                        className='cursor-pointer hover:opacity-80 flex items-center justify-center'
                                                        style={{
                                                            height: '38px',
                                                            backgroundColor: '#F5F5F5',
                                                            padding: '10px 20px',
                                                            borderRadius: '16px',
                                                        }}
                                                    >
                                                        <p style={{
                                                            fontFamily: 'Inter, sans-serif',
                                                            fontWeight: 400,
                                                            fontSize: '15px',
                                                            lineHeight: '100%',
                                                            letterSpacing: '-0.02em',
                                                            color: '#101010',
                                                        }}>{item.name}</p>
                                                    </div>
                                                ))}
                                                <div
                                                    onClick={() => { setReviewsModal(true) }}
                                                    className='cursor-pointer hover:opacity-80 flex items-center justify-center'
                                                    style={{
                                                        height: '38px',
                                                        backgroundColor: '#F5F5F5',
                                                        padding: '10px 20px',
                                                        borderRadius: '16px',
                                                    }}
                                                >
                                                    <p style={{
                                                        fontFamily: 'Inter, sans-serif',
                                                        fontWeight: 400,
                                                        fontSize: '15px',
                                                        lineHeight: '100%',
                                                        letterSpacing: '-0.02em',
                                                        color: '#101010',
                                                    }}>Download Reviews</p>
                                                </div>
                                            </div>
                                        )}
                                        {showAdditionals === 'trips' && !PartnerGuard() &&
                                            <div className='w-full mt-2'>
                                                <ExecutiveTrips
                                                    items={items}
                                                    hasNextPage={hasNextPage}
                                                    onShowMore={onShowMore}
                                                    loadingMore={loadingMore}
                                                    hideHeader
                                                />
                                            </div>
                                        }
                                    </div>
                                )}
                                {PartnerGuard() &&
                                    <div className='px-3 py-3 bg-[#fff] dark:bg-[#111317] min-w-full border-b border-b-1'>
                                        <ExecutiveTrips
                                            items={items}
                                            hasNextPage={hasNextPage}
                                            onShowMore={onShowMore}
                                            loadingMore={loadingMore}
                                        />
                                    </div>
                                }
                                <div className='px-5 py-4 dark:bg-[#111317]'>
                                    <Outlet />
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </main>
            </div>
            {rightSidebarOpen && (
                <div className="fixed inset-0 z-40 flex md:hidden">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setRightSidebarOpen(false)}></div>
                    <div className="relative bg-white dark:bg-bgColor-darkMode w-70 h-full shadow-xl z-50 overflow-y-auto">
                        <div className="flex justify-end p-3 pr-[10px]">
                            <button onClick={() => setRightSidebarOpen(false)}>
                                <img src="/assets/shared/close-grey.svg" alt="Close" className="w-5 h-5" />
                            </button>
                        </div>
                        <RightSidebar onClickOpenChat={onClickAction} isMobile={true} onOpenHodReport={onOpenHodReport} onOpenTmReport={onOpenTmReport} />
                    </div>
                </div>
            )}
            <RightSidebar
                onClickOpenChat={onClickAction}
                isCollapsed={isRightSidebarCollapsed}
                toggleCollapse={() => setIsRightSidebarCollapsed(!isRightSidebarCollapsed)}
                onOpenHodReport={onOpenHodReport}
                onOpenTmReport={onOpenTmReport}
            />
            {showSearchChat && (
                <NewChatModal
                    openModal={showSearchChat}
                    handleCloseModal={onClickShowModal}
                    onClickOpenChat={onTryingToOpenChat}
                />
            )}
            {openReportModal?.show &&
                <DocEditor
                    open={openReportModal?.show}
                    onClose={() => setOpenReportModal(undefined)}
                    url={openReportModal?.url}
                    data={openReportModal?.data} />
            }
            <HodReportModal
                open={hodReportModal.show}
                tripId={hodReportModal.tripId}
                reportType={hodReportModal.reportType}
                onClose={() => setHodReportModal({ show: false, tripId: '', reportType: 'cabin' })}
            />
            <TmReportModal
                open={tmReportModal.show}
                tripId={tmReportModal.tripId}
                onClose={() => setTmReportModal({ show: false, tripId: '' })}
            />
        </div>
    );
};

export default LayoutAdmin;
